'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssignedAgentId = exports.default = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _KeyPaths = require('../../thread/constants/KeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAssignedAgentId = (0, _getIn2.default)(_KeyPaths.ASSIGNEE);

exports.default = getAssignedAgentId;
exports.getAssignedAgentId = getAssignedAgentId;